// AutoSave.js
import { debounce, isEqual } from 'lodash';
import React, { useRef, useEffect, useMemo } from 'react';

const AutoSave = ({ values, onSave }) => {
  const previousValuesRef = useRef(values);

  // Create a debounced onSave function
  const debouncedOnSave = useMemo(
    () =>
      debounce(currentValues => {
        if (onSave) {
          onSave(currentValues);
        }
      }, 1500),
    [onSave]
  );

  useEffect(() => {
    // Only call onSave if values actually changed
    if (!isEqual(previousValuesRef.current, values)) {
      debouncedOnSave(values);
      previousValuesRef.current = { ...values }; // Create a new object reference
    }

    return () => {
      //   debouncedOnSave.flush(); // Flush any pending changes before unmounting
      debouncedOnSave.cancel();
    };
  }, [values, debouncedOnSave]);

  return null; // Nothing to render
};

export default AutoSave;
